import { memo } from 'react';
import { Box, Icon, Text } from '@chakra-ui/react';

import DashboardIcon from 'components/Icons/DashboardIcon';
import DashboardIconActive from 'components/Icons/DashboardIconActive';

import { NavigationButtonProperties } from '../types';
import { COLORS, BUTTON_STYLES } from '../constants';

const NavigationButton = memo(({ icon, label, isActive, onClick }: NavigationButtonProperties) => {
  const isDashboardIcon = icon === DashboardIcon || (icon as any)?.name === 'DashboardIcon';

  return (
    <Box
      as='div'
      display='inline-flex'
      alignItems='center'
      justifyContent='center'
      cursor='pointer'
      px='24px'
      py='10px'
      {...BUTTON_STYLES}
      borderRadius='full'
      height={'31px'}
      color={isActive ? COLORS.ACTIVE_TEXT : COLORS.INACTIVE_TEXT}
      bg={isActive ? COLORS.ACTIVE_BG : 'transparent'}
      flexShrink={0}
      _hover={{ bg: isActive ? COLORS.ACTIVE_HOVER : 'gray.100' }}
      _active={{ bg: isActive ? COLORS.ACTIVE_PRESSED : 'gray.200' }}
      onClick={onClick}
    >
      <>
        {isDashboardIcon ? (
          <Box boxSize={5} display='flex' alignItems='center' justifyContent='center' mr={2}>
            {isActive ? (
              <DashboardIconActive width={20} height={20} />
            ) : (
              <DashboardIcon width={20} height={20} />
            )}
          </Box>
        ) : (
          <Icon
            as={icon}
            boxSize={5}
            color={isActive ? COLORS.ACTIVE_TEXT : COLORS.INACTIVE_TEXT}
            mr={2}
          />
        )}
        <Text
          fontSize='12px'
          fontWeight='500'
          color={isActive ? COLORS.ACTIVE_TEXT : COLORS.INACTIVE_TEXT}
        >
          {label}
        </Text>
      </>
    </Box>
  );
});

NavigationButton.displayName = 'NavigationButton';

export default NavigationButton;
